module.exports = __webpack_public_path__ + "/build/web/images/logos/budget-blinds/budget-blinds@3x.d2cd1378fe015c4041a3f13bc56e345f.png";


//////////////////
// WEBPACK FOOTER
// ./images/logos/budget-blinds/budget-blinds@3x.png
// module id = 162
// module chunks = 13